import { render, staticRenderFns } from "./SwitchingCompany.vue?vue&type=template&id=01dad1d8&scoped=true&"
import script from "./SwitchingCompany.vue?vue&type=script&lang=js&"
export * from "./SwitchingCompany.vue?vue&type=script&lang=js&"
import style0 from "./SwitchingCompany.vue?vue&type=style&index=0&id=01dad1d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dad1d8",
  null
  
)

export default component.exports